// Rapikan nama kota untuk tampilan customer.
//
// Data kota Indonesia (CountryId 102) menyimpan awalan administratif —
// "Kota Ambon", "Kota Administrasi Jakarta Barat" — yang tak perlu tampil ke
// tamu. Awalan ini khas Bahasa Indonesia, jadi kota negara lain tak akan
// pernah diawali "Kota " → pengupasan aman dilakukan di FE tanpa perlu tahu
// CountryId (yang memang tak dibawa payload kartu/pencarian).
//
// Hanya awalan di DEPAN yang dikupas: "Kabupaten Kota Baru" TIDAK tersentuh,
// dan "Kotabaru" (tanpa spasi) juga tidak — pemisah spasi wajib.
export function formatCityName(name) {
    if (!name || typeof name !== "string") return name ?? "";
    return name.replace(/^Kota(\s+Administrasi)?\s+/i, "").trim();
}
